import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { useFlag } from '@mentimeter/flags/confidence/client';
import { PageLayout, ProgressBar } from '../../ui';
import { Qfa } from '../qfa/Qfa';
import { FinishScreen } from './FinishScreen';
import { FinishScreenFooter } from './FinishScreenFooter';
import type { FinishScreenProps } from './FinishScreenProps';
import { BeesActionableFeedbackExperiment } from './BeesActionableFeedbackExperiment';

export const VotingScreenDefaultLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <PageLayout footer={<FinishScreenFooter />}>
      <Box width="100%" maxWidth="320px" alignItems="center">
        {children}
      </Box>
    </PageLayout>
  );
};

export const FinishScreenExperiment = () => {
  return (
    <>
      <ProgressBar progress={1} />
      <FinishScreenExperimentContent qfa={<Qfa isFinishScreen />} />
    </>
  );
};

export const FinishScreenExperimentContent = (props: FinishScreenProps) => {
  const { value: actionableFeedbackVersion } = useFlag(
    'bees-actionable-feedback.version',
    'off',
  );

  if (
    actionableFeedbackVersion === 'stars_only' ||
    actionableFeedbackVersion === 'stars_and_structured_feedback' ||
    actionableFeedbackVersion === 'stars_and_unstructured_feedback' ||
    actionableFeedbackVersion === 'stars_and_random_feedback'
  ) {
    return (
      <BeesActionableFeedbackExperiment
        version={actionableFeedbackVersion}
        {...props}
      />
    );
  }
  return <FinishScreen {...props} />;
};
